const MobileForgotPasswordForm = ({ form, onSubmit }) => {
	const { register, handleSubmit, formState } = form;
	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex flex-col gap-[16px] w-full"
		>
			{/* Email Input */}
			<input
				type="text"
				placeholder="Email"
				{...register("email")}
				className="w-full h-[33px] rounded-[8px] border border-[#193D34] p-[8px] outline-none"
			/>
			{formState.errors.email && (
				<p className="text-red-500 text-sm mt-1">
					{formState.errors.email.message}
				</p>
			)}
			<div className="w-full flex flex-col items-center justify-center gap-[16px]">
				<button className="flex items-center justify-center w-[112px] h-[32px] rounded-[24px] p-[8px] bg-[#B7D974] text-[#193D34] text-[13px] font-[500] font-montserrat leading-[24px] text-center">
					Send Request
				</button>
			</div>
		</form>
	);
};

export default MobileForgotPasswordForm;
